import { render } from "./UnauthenticatedFooter.vue?vue&type=template&id=c353b978"
const script = {}

import exportComponent from "/codebuild/output/src3689317901/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-prod-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__